import React, { Fragment } from 'react';
import Award from '../Award/';
import Typography from '@material-ui/core/Typography';

const TitlesProfile = props => {
  const { title, subtitle, awardIcon, status } = props;
  return (
    <Fragment>
      <div
        style={{
          display: 'flex',
          flexFlow: 'row',
          justifyContent: 'space-between',
        }}
      >
        <div style={{ width: '100%', maxWidth: 704 }}>
          <Typography
            style={{ fontWeight: 'bold', color: '#10587f', fontSize: 22, lineHeight: 'normal', marginBottom: 8}}
          >
            {title}
          </Typography>
          <Typography
            style={{ fontWeight: 'normal', color: '#484848', fontSize: 16, lineHeight: 'normal' }}
          >
            {subtitle}
          </Typography>
        </div>
        <div>
          {awardIcon? <Award active={status}/>:null}
        </div>
      </div>
      <div style={{ maxWidth: '100%' }}>
        <hr style={{ height: 1, backgroundColor: '#c1c1c1', marginTop: 8 }}/>
      </div>
    </Fragment>
  );
};

export default TitlesProfile;
